import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { map, keys, reduce, snakeCase, find } from 'lodash';
import ProgramType from '../../../../components/program-type';
import ProductRow from './UnifyMappingTableProductRow';

class UnifyMappingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderProductList(program) {
    const { refs, products } = this.props;
    const indexedProducts = refs[program.client_id] && refs[program.client_id][program.program_id] ? refs[program.client_id][program.program_id] : {};
    
    const programProducts = reduce(indexedProducts, (items, productName, productId) => {
      const { mappings } = (find(products, { id: productId }) || { mappings: {} });
   
      items.push({
        id: productId,
        name: productName,
        selected: mappings[program.client_id] && mappings[program.client_id][program.program_id] ? mappings[program.client_id][program.program_id] === productId : false,
      });
      return items;
    }, []);
    if (programProducts.length === 0) {
      return (
        <div className="text-warning">
          <Fa name="exclamation-triangle" /> Please setup and enable at least one product in TruVoice first.
        </div>
      );
    }
    return (
      <table style={{ margin: 0 }} className="table table-condensed table-bordered table-hover table-stripped">
        <tbody>
          {programProducts.map((product) => {
            return (
              <ProductRow
                key={product.id}
                program={program}
                product={product}
              />
            );
          })}
        </tbody>
      </table>
    );
  }

  renderProgramSection(program) {
    return (
      <tr key={program.program_id}>
        <td>&nbsp;</td>
        <td>{program.name}</td>
        <td width="50%">{this.renderProductList(program)}</td>
      </tr>
    );
  }

  renderProgramTypeSection(sectionName, programs, isLast = false) {
    const k = snakeCase(sectionName);
    return [
      (
        <thead key={`header-${k}`}>
          <tr>
            <th width="25" style={{ paddingLeft: '15px' }}><ProgramType type={sectionName} /></th>
            <th colSpan="2" className="text-uppercase">
              <h5 style={{ margin: 0 }}>{sectionName}</h5>
            </th>
          </tr>
        </thead>
      ),
      (
        <tbody key={`body-${k}`}>
          {programs.map((program) => {
            return this.renderProgramSection(program)
          })}
          {!isLast && <tr><td style={{ borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }} colSpan="3">&nbsp;</td></tr>}
        </tbody>
      ),
    ];
  }

  render() {
    const { programs } = this.props;
    const total = keys(programs).length;
    let i = 0;
    const sections = map(programs, (progs, sectionName) => {
      i += 1;
      return this.renderProgramTypeSection(sectionName, progs, i >= total);
    });


    return (
      <div>
        <table className="table table-condensed table-striped table-bordered">
          {sections}
        </table>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

UnifyMappingTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  programs: PropTypes.shape({}).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  refs: PropTypes.shape({}).isRequired,
};
UnifyMappingTable.defaultProps = {
};

export default connect(mapStateToProps)(UnifyMappingTable);
